import { ActionTree } from "vuex";
import { TimelineState } from ".";
import { RootState } from "..";
import timelineApi from "../../api/timeline.api";
import { RootActionTypes } from "../root-actions";
import { TimelineMutationTypes } from "./timeline.mutations";
import * as Sentry from "@/utils/logger.util";

export const TimelineActionTypes = {
  FetchTimeline: "FETCH_TIMELINE"
};

export const actions: ActionTree<TimelineState, RootState> = {
  async [TimelineActionTypes.FetchTimeline]({ commit, dispatch }, payload: { page: number }) {
    try {
      const response = await timelineApi.getTimeline(payload.page);
      commit(TimelineMutationTypes.SetTimeline, response.data);
    } catch (error) {
      Sentry.captureException(error);
      dispatch(RootActionTypes.HandleApiError, error, { root: true });
    }
  }
};
